export default "__VITE_ASSET__Btdt$_ZW__"